/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import Validation from "../../../../../utils/validation";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonLayout from "../../../../_utils/CommonLayout";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";

const FieldForceContactDetails = (props) => {
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const categories = props.categories;

  const allCategoryIds = useMemo(() => {
    return categories.map((category) => category.id);
  }, []);
  const isAllSelected = useMemo(() => {
    return props?.selectedCatFields.length === allCategoryIds.length;
  }, [props?.selectedCatFields, allCategoryIds]);

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > GlobalConfiguration.lengthCheckZero) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.id : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.id);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  const emailRegex = Validation.emailRegex;

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    value = modifyValue(name, value?.replace(/\s/g, ""));

    if (props.payload) {
      if (allowedValue(name, value)) {
        validateAndRecordError(name, value);
        const newObj = { ...props.payload, [name]: value };
        props?.setPayload(newObj);
      }
      if (
        props?.payload?.contact_no &&
        (props?.payload?.contact_no?.length ===
          GlobalConfiguration.lengthCheckZero ||
          props?.payload?.contact_no?.length < GlobalConfiguration.panLength)
      ) {
        setContactNumberValidation(false);
      }
      if (
        props?.payload?.email_id &&
        props?.payload?.email_id?.length === GlobalConfiguration.lengthCheckZero
      ) {
        setEmailValidation(false);
      }
    }
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (
      !customErrors["contact_no"] &&
      props.payload.contact_no?.length === GlobalConfiguration.panLength
    ) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      props.payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(props.payload.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, props.payload]);

  useEffect(() => {
    if (emailValidation && contactNumberValidation) {
      props.BenEnableNextButton(false);
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
      });
    } else if (props?.activeStep === GlobalConfiguration.lengthCheckZero) {
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
      });
      props.BenEnableNextButton(true);
    }
    handleCategorySelect(props?.selectedCatFields);
  }, [
    props?.selectedCatFields,
    isAllSelected,
    emailValidation,
    contactNumberValidation,
    props?.activeStep,
  ]);

  return (
    <>
      <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <CommonDestinationAccount
            variant="user"
            isOptional={false}
            transactionPayload={props?.payload}
            setTransactionPayload={props?.setPayload}
            onSelectAccount={props?.onOpenUserPopup}
            onDeleteAccount={() => {
              const wasUsername = props?.selectedValue === "username";
              props?.setPayload((prev) => ({
                ...prev,
                linked_user_id: "",
                ...(wasUsername && { account_name: prev.legalName || "" }),
              }));
              if (wasUsername) props?.setSelectedValue("legalname");
            }}
          />

          <ContactDetails
            handleChange={handleChange}
            contactNumberValidation={contactNumberValidation}
            emailValidation={emailValidation}
            contactNumber={props.payload.contact_no}
            emailId={props.payload.email_id}
            selectedValue={props?.selectedValue}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default FieldForceContactDetails;
